import React, { useCallback } from 'react';
import { noop } from '@prisjakt/ui-base';
import { ListFilterItem } from 'src/components/filter-section/types';
import * as S from 'src/components/filter-section/components/list/styles';

type RadioButtonProps = {
  item: ListFilterItem;
  selected: boolean;
  onClick: (id: string, value: string) => void;
};

const RadioButton = ({ item, selected, onClick }: RadioButtonProps) => {
  const { id, value, count, path, indexable } = item;
  const disabled = !selected && count === 0;
  const onClickItem = useCallback(
    (e: React.MouseEvent<Element, MouseEvent>) => {
      // Help google with a-links, but handle filter updates via actions
      e.preventDefault();
      onClick(id, value);
    },
    [onClick, id, value]
  );

  return (
    <S.OptionListItem disabled={disabled} key={id}>
      <S.Option
        to={(indexable && path) || undefined}
        onClick={disabled ? noop : onClickItem}
      >
        <S.RadioButton checked={selected} />
        <S.Name>{value}</S.Name>
        {count !== undefined && <S.Count>{count}</S.Count>}
      </S.Option>
    </S.OptionListItem>
  );
};

type Props = {
  items: ListFilterItem[];
  getSelectedState: (id: string) => boolean;
  onClickItem: (id: string, value: string) => void;
};

const RadioButtons = ({ items, getSelectedState, onClickItem }: Props) => {
  return (
    <>
      {items.map(item => (
        <RadioButton
          key={item.id}
          item={item}
          selected={getSelectedState(item.id)}
          onClick={onClickItem}
        />
      ))}
    </>
  );
};

export default RadioButtons;
